import { gql } from '@apollo/client';

const GET_ATM_USERS = gql`
  query GetOrgAtmUsers {
    orgAtmUsers {
      ExternalUserId
      Name
      CurrentRoleName
    }
  }
`;

export default GET_ATM_USERS;
